<ng-select
    [class]="enableDropdownStyling ? 'e-selector-search-drop' : 'e-selector-search'"
    [items]="filteredOptions"
    bindLabel="name"
    [(ngModel)]="selectedValues"
    (search)="search($event.term)"
    placeholder="Search within tree"
    dropdownPosition="bottom"
    [multiple]="true"
    [clearable]="true"
    [searchable]="true"
    [notFoundText]="'No results found'"
    [hideSelected]="true"
    [clearOnBackspace]="false"
    [closeOnSelect]="false"
    [isOpen]="openSearch"
    (clear)="onClear()"
    (add)="onFilterSelection($event)"
>
    <ng-template ng-multi-label-tmp>
        <span style="display: block" class="ng-placeholder"></span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <span class="e-label" title="{{ item.name }}">{{ item.name }}</span> <br />
        <span class="e-hierarchy" title="{{ item.hierarchy }}">{{ item.hierarchy }}</span>
    </ng-template>
</ng-select>
